<template>
  <section>
    <MainGameInfo ref="MainGameView" @showWXTips="showWXTips" @downLoad="downLoad"/>
    <UserAuth ref="UserAuthView" :showKF="false" @authSuc="authSuc"/>
    <plistTips ref="plistTipsView"/>
    <wxTips ref="wxTipsView"/>
  </section>
</template>
<script>
import UserAuth from "../../components/LandingPage/UserAuth";
import plistTips from "../../components/LandingPage/plistTips";
import wxTips from "../../components/LandingPage/wxTips";
import MainGameInfo from "../../components/LandingPage/MainGameInfo";

export default {
  components: {
    MainGameInfo,
    UserAuth,
    plistTips,
    wxTips,
  },
  data() {
    return {
      mRunRomSystem: "android",
      gameDownloadUrl: '',
    }
  },
  created() {
    this.mRunRomSystem = this.runRomSystem();
  },
  methods: {
    downLoad(resData,downLoadType, gameDownloadUrl) {
      this.gameDownloadUrl = gameDownloadUrl;
      switch (downLoadType) {
        case 1:
          if (this.mRunRomSystem === "ios") {
            this.$refs.plistTipsView.showPlistTipsView();
          }
          window.location.href = gameDownloadUrl;
          break;
        case 2:
          document.location.href = gameDownloadUrl;
          break;
        default:
          this.$refs.UserAuthView.showRegister();
          break;
      }
    },
    showWXTips() {
      this.$refs.wxTipsView.showWXTipsView();
    },
    authSuc() {
      document.location.href = this.gameDownloadUrl;
    },
  }
};
</script>

<style scoped lang='less'>
@import "../../assets/css/home/index.less";
</style>





// WEBPACK FOOTER //
// game.vue?e68d4310